export default "__VITE_ASSET__BRMAnQ93__"